import { Flex, Text } from "@radix-ui/themes";
import React from "react";

interface Props {
  cocode: string;
}

const ConsignorBadge = ({ cocode }: Props) => {
  return (
    <Flex className="bg-indigo-50 text-indigo-900 items-center align-middle justify-center px-2 py-1 gap-1 rounded-lg h-full">
      <span className="material-icons-outlined text-[6px] flex-shrink-0">
        hexagon
      </span>
      <Text className="whitespace-nowrap truncate flex-1 text-sm">
        {cocode}
      </Text>
    </Flex>
  );
};

export default ConsignorBadge;
